export default {
  brand: 'Sun Power',
  studio: '工作室',
  lottery: '幸运抽奖',
  companyHome: '公司首页',
  companyHomeNotConfigured: '暂未配置公司首页链接',
  game: '游戏圈',
  profile: '个人中心',
  service: '人工客服',
  serviceNotConfigured: '暂未配置客服链接',
  language: '语言',
  login: '登录',
  register: '注册',
  email: '邮箱',
  password: '密码',
  inviteCode: 'UID',
  uid: 'UID',
  shareLink: '分享链接',
  copyLink: '复制链接',
  copied: '已复制',
  copyFail: '复制失败',
  recharge: '充值',
  withdraw: '提现',
  exchange: '兑换',
  balanceUsd: '账户余额',
  balanceKwh: '储备电量',
  checkin: '签到',
  upgrade: '晋升等级',
  team: '我的团队',
  basic: '基础产品',
  vip1: 'VIP1产品',
  vip2: 'VIP2专属',
  vip3: 'VIP3专属',
  activity: '活动产品',
  unitPrice: '单价',
  quantity: '订购数量',
  minQtyTip: '起订量 {n} 份',
  expectKwh: '预计电量',
  totalAmount: '购买总金额',
  progress: '已订购进度',
  buy: '购买',
  buyConfirm: '确认购买',
  confirmBuy: '确认支付',
  buyConfirmTip: '将从 USD 账户扣款，确认后不可撤销',
  buySuccess: '购买成功',
  productName: '产品名称',
  amount: '金额',
  rechargeRate: '充值汇率',
  rechargeActual: '实际到账',
  enterAmount: '请输入金额',
  network: '网络',
  selectNetwork: '请选择网络',
  withdrawAddress: '收款地址',
  enterWithdrawAddress: '请输入钱包地址',
  txHash: '交易哈希',
  txHashOptional: '选填，转账后填写',
  copyAddress: '复制地址',
  rechargeHint: '请向以下地址转入等额 USDT，提交后将尽快为您入账',
  withdrawHint: '申请后将冻结余额；手续费按费率扣除后打款至您的钱包',
  withdrawFeeRate: '手续费率',
  withdrawFee: '手续费',
  withdrawReceive: '预计到账',
  withdrawTooLow: '扣除手续费后到账金额过低',
  rechargeSubmitted: '充值申请已提交',
  withdrawSubmitted: '提现申请已提交',
  noQr: '暂无二维码',
  noRechargeAddress: '该通道暂未配置收款地址，请联系客服',
  rechargeProof: '充值凭证',
  rechargeProofTip: '请上传转账成功截图',
  rechargeProofRequired: '请上传充值凭证',
  confirm: '确认',
  cancel: '取消',
  kyc: '实名认证',
  realName: '真实姓名',
  idCard: '证件号',
  contact: '联系方式',
  contactPlaceholder: '手机号 / WhatsApp / Telegram 等',
  contactRequired: '请填写联系方式',
  idFront: '证件正面',
  idBack: '证件反面',
  kycStatus: '认证状态',
  kycNone: '未认证',
  kycPending: '处理中',
  kycApproved: '已通过',
  kycRejected: '未通过',
  kycTip: '请填写真实信息并上传证件正反面，提交后将尽快完成认证',
  kycRequired: '请填写姓名和证件号',
  kycNeedPhotos: '请上传证件正反面照片',
  kycSubmitted: '已提交，请耐心等待',
  submit: '提交',
  logout: '退出登录',
  appDownload: 'APP下载',
  downloadPickTip: '请选择您的手机系统，然后按引导安装',
  downloadAndroidShort: 'APK 安装包（Android）',
  downloadIosShort: '配置描述文件（iPhone / iPad）',
  downloadNow: '立即下载',
  downloadAndroidSteps: [
    '点击下方按钮下载 APK 安装包',
    '打开「文件 / 下载」找到 Sun Power 安装包并点击',
    '若出现 Google Play Protect「已拦截应用」提示：点「仍然安装 / Install anyway」',
    '若提示禁止未知来源：进入 设置 → 应用 → 特殊应用权限 → 安装未知应用，允许当前浏览器或文件管理器',
    '按屏幕提示完成安装后打开 Sun Power'
  ],
  downloadIosSteps: [
    '点击下方按钮，Safari 将打开安装描述文件',
    '若提示已下载描述文件：打开 设置 → 已下载描述文件（或 通用 → VPN与设备管理）',
    '点「安装」，输入锁屏密码后确认安装',
    '安装完成后回到桌面打开 Sun Power',
    '若无法打开：设置 → 通用 → VPN与设备管理 → 找到该描述文件并点「信任」'
  ],
  downloadAndroidNote: '此应用来自官网直接下载，不属于 Google Play。Play Protect 提示属于正常安全提醒，选择「仍然安装」即可。',
  downloadIosNote: '请使用 Safari 浏览器完成安装。其他浏览器可能无法正确安装描述文件。',
  downloadStarting: '正在准备下载…',
  downloadStarted: '已开始下载，请到浏览器或通知栏查看',
  downloadIosStarted: '正在打开安装文件，请按提示完成安装',
  downloadFail: '下载失败，请稍后重试',
  downloadUnavailable: '暂无安装包，请联系客服',
  legalLicense: '合法许可',
  businessReward: '经营与奖励',
  companyNews: '公司最新消息',
  newsEmpty: '暂无消息',
  newsAttachment: '查看附件',
  loading: '加载中…',
  attachmentLoadFail: '附件加载失败，请稍后重试',
  vipLevelNotify: 'VIP等级通知',
  vipLevelChanged: '您的VIP等级已从 {from} 变更为 {to}',
  gotIt: '我知道了',
  loginNotice: '通知',
  roulette: '俄罗斯轮盘',
  prizes: '奖品列表',
  lotteryRules: '抽奖规则',
  draw: '抽奖',
  lotteryTimes: '抽奖次数',
  lotteryWin: '恭喜获得',
  lotteryThanks: '谢谢参与',
  lotteryThanksShort: '谢谢',
  lotteryThanksTip: '很遗憾，本次未中奖，下次再试',
  lotteryRewardTip: '奖励 {reward} 已发放到账户',
  lotteryTimesReward: '获得 {n} 次抽奖机会',
  lotteryNoChance: '暂无抽奖次数',
  catchSun: '接阳光',
  startGame: '开始游戏',
  score: '得分',
  timeLeft: '剩余时间',
  gameOver: '游戏结束',
  reward: '奖励',
  timesLeft: '剩余次数',
  gameNoChance: '今日次数已用完',
  announcement: '公告',
  noData: '暂无数据',
  loginTip: '邮箱登录，无需验证',
  registerTip: '填写 UID 完成注册',
  emailPlaceholder: '请输入邮箱',
  passwordPlaceholder: '请输入密码',
  confirmPassword: '确认密码',
  confirmPasswordPlaceholder: '再次输入密码',
  invitePlaceholder: '请输入 UID',
  emailRequired: '请填写邮箱',
  passwordRequired: '请填写密码',
  passwordMin: '密码至少 6 位',
  confirmPasswordRequired: '请确认密码',
  passwordMismatch: '两次密码不一致',
  inviteRequired: '请填写 UID',
  noAccount: '还没有账号？',
  hasAccount: '已有账号？',
  registerSuccess: '注册成功',
  show: '显示',
  hide: '隐藏',
  back: '返回',
  level: '等级',
  checkinDays: '连续签到',
  checkinTip: '连续签到 {days} 天可获得 1 次抽奖机会',
  doCheckin: '立即签到',
  alreadyCheckin: '今日已签到',
  checkinSuccess: '签到成功',
  checkinLottery: '签到成功，获得 1 次抽奖机会',
  upgradeTip: 'VIP1 晋升需同时满足以下条件',
  kycDone: '完成实名',
  firstRecharge: '自身首充',
  inviteKyc: '拉新实名',
  inviteRecharge: '直推首充',
  teamCount: '直推人数',
  teamL1: '一级',
  teamL2: '二级',
  teamL3: '三级',
  teamAll: '全部',
  teamInviter: '邀请我的人',
  teamInviterNone: '暂无上级（非会员邀请注册）',
  teamDownline: '我邀请的人',
  teamUpL1: '上级一级',
  teamUpL2: '上级二级',
  teamUpL3: '上级三级',
  teamUpRel1: '直接邀请您的人',
  teamUpRel2: '邀请您上级的人',
  teamUpRel3: '再上一级推荐人',
  teamParentSelf: '直推成员（由您直接邀请）',
  teamParentL1: '一级推荐人',
  teamParentL2: '二级推荐人',
  teamRefByL1: '由一级 {email} 推荐',
  teamRefByL2: '由二级 {email} 推荐',
  teamRefL1: '所属一级 {email}',
  logs: '账户流水',
  myOrders: '我的订单',
  dailyRebate: '每日分红',
  rebateToday: '今日分红',
  rebateTotal: '累计分红',
  rebateTip: '每日按储备电量（kWh 账户）余额×利率释放：扣减 kWh 并按汇率兑入 USD；买产品用于增加 kWh 余额从而提升日返',
  totalKwh: '总电量',
  pendingKwh: '待释放',
  releasedKwh: '已释放',
  orderStatus: {
    '0': '进行中',
    '1': '已完成',
    '2': '已关闭'
  },
  exchangeTip: '将储备电量兑换为账户余额（USD）',
  exchangeAvailable: '可用电量',
  exchangeRate: '兑换汇率',
  exchangeFee: '手续费',
  exchangeAmountKwh: '兑换数量',
  exchangeAll: '全部',
  exchangeReceive: '预计到账',
  exchangeExceed: '超过可用电量',
  exchangeNoKwh: '暂无可兑换电量',
  success: '成功',
  playing: '游戏中',
  tapSun: '点击下落的阳光得分',
  accountType: {
    USD: 'USD',
    KWH: 'kWh'
  },
  logType: {
    RECHARGE: '充值',
    WITHDRAW: '提现',
    WITHDRAW_REFUND: '提现退回',
    EXCHANGE: '兑换',
    GAME: '游戏奖励',
    LOTTERY: '抽奖',
    INVITE_KYC: '拉新实名奖励',
    BUY_PRODUCT: '购买产品',
    REBATE_Ln: '{n}级返佣',
    REBATE_L1: '一级返佣',
    REBATE_L2: '二级返佣',
    REBATE_L3: '三级返佣',
    DAILY_REBATE: '日返',
    MANAGE_REWARD: '管理奖',
    ADMIN_ADJUST: '后台调账'
  }
}
